import { create } from 'zustand'

interface UnsavedChangesState {
  /** Whether the currently-mounted dirty-tracking source has unsaved edits. */
  isDirty: boolean
  setDirty: (dirty: boolean) => void
  /** The navigation action waiting on user confirmation, or null if none. */
  pendingAction: (() => void) | null
  /**
   * Call this from any navigation trigger instead of navigating directly.
   * Runs `action` immediately if nothing is dirty; otherwise holds it until
   * the user confirms or cancels via the global UnsavedChangesPrompt.
   */
  requestNavigation: (action: () => void) => void
  confirmNavigation: () => void
  cancelNavigation: () => void
}

export const useUnsavedChangesStore = create<UnsavedChangesState>((set, get) => ({
  isDirty: false,
  setDirty: (dirty) => set({ isDirty: dirty }),
  pendingAction: null,
  requestNavigation: (action) => {
    if (!get().isDirty) {
      action()
      return
    }
    set({ pendingAction: action })
  },
  confirmNavigation: () => {
    const action = get().pendingAction
    set({ pendingAction: null, isDirty: false })
    action?.()
  },
  cancelNavigation: () => set({ pendingAction: null }),
}))
